import axios from "axios";
import { useNavigate } from 'react-router-dom';

const port: number = 80;

//export const BASE_URL = `https://janilsonjvs.pythonanywhere.com${port !== 80 ? ':'+port.toString() : ''}/api/`;
// export const BASE_URL_MAIN = `http://laravel.test:${port}/`;
// export const BASE_URL = `http://laravel.test:${port}/api/`;
export const BASE_URL_MAIN = `https://mdfe-api.plugsystem.natal.br/`;
export const BASE_URL = `https://mdfe-api.plugsystem.natal.br/api/`;

const api = axios.create({
    baseURL: BASE_URL,
    headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Cache-Control": "no-cache",
    },

    withCredentials: true,
    withXSRFToken: true
    
});


api.interceptors.request.use(
    async config => {
        const token = localStorage.getItem('token');
        const empresa =  localStorage.getItem('empresa') || '0';
        
        if (token != "") {
            config.headers["Authorization"] = `Bearer ${token}`;
            config.headers["manifesto-empresa-logada"] = empresa;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

api.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response && error.response.status === 401) {
        // Redireciona para login se não autenticado
        const navigate = useNavigate();
        navigate('/login');
      }
      return Promise.reject(error);
    }
  );
export default api;